import { OverlayContainer } from '@angular/cdk/overlay';
import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class AtsOverlayContainer extends OverlayContainer {
	public atsCreateContainer(el: ElementRef) {
		const container = document.createElement('div');
		container.style.pointerEvents = 'none';
		el.nativeElement.appendChild(container);
		this._containerElement = container;
	}

	protected _createContainer(): void {
		return;
	}
}
